export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门推荐', href: '#cards' },
  { label: '热播榜单', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
  { label: '手机看片', href: '#app' },
  { label: '联系我们', href: '#contact' },
];

export const heroTags = ['每日更新', '全网资源整合', '高清无广告'];

export const heroStats = [
  { label: '收录影片', value: '10万+' },
  { label: '每日更新', value: '300+' },
  { label: '在线观看', value: '秒加载' },
];

export const indexItems = [
  { title: '动作大片', icon: 'ri-fire-fill', color: 'primary', description: '热血激战、超燃打斗，肾上腺素飙升的视觉盛宴' },
  { title: '热门韩剧', icon: 'ri-heart-pulse-fill', color: 'accent', description: '最新韩剧同步更新，浪漫爱情与悬疑烧脑一网打尽' },
  { title: '喜剧合集', icon: 'ri-emotion-laugh-fill', color: 'primary', description: '笑到停不下来，国产喜剧与好莱坞爆笑不断' },
  { title: '科幻巨制', icon: 'ri-rocket-fill', color: 'secondary', description: '宇宙探索、未来科技，震撼视觉与烧脑剧情并存' },
  { title: '国产热剧', icon: 'ri-tv-fill', color: 'accent', description: '国产精品剧集持续追踪，古装权谋与现代职场任你选' },
  { title: '恐怖惊悚', icon: 'ri-ghost-fill', color: 'primary', description: '胆小慎入！日韩泰恐怖片与欧美悬疑惊悚应有尽有' },
  { title: '动漫番剧', icon: 'ri-live-fill', color: 'secondary', description: '日漫国漫同步追番，热血冒险与治愈日常陪你度过每一天' },
  { title: '综艺娱乐', icon: 'ri-music-fill', color: 'accent', description: '热门综艺一睹为快，音乐竞演与真人秀精彩不停' },
  { title: '纪录片', icon: 'ri-earth-fill', color: 'primary', description: '自然奇观、人文历史，用镜头探索世界的每一个角落' },
];

export const cardItems = [
  {
    title: '《流浪地球3》重磅回归',
    tag: '科幻冒险',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20earth%20engines%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20cool%20blue%20and%20orange%20tones%2C%20grand%20scale%2C%20movie%20poster%20style%20with%20Chinese%20text%20space%2C%20clean%20background&width=800&height=500&seq=card-01&orientation=landscape',
    description: '人类命运再临挑战，地球启航驶向新家园，国产科幻巅峰之作',
  },
  {
    title: '《狂飙：暗流》前传上线',
    tag: '国产剧集',
    image: 'https://readdy.ai/api/search-image?query=Dark%20crime%20drama%20movie%20poster%20with%20urban%20night%20scene%2C%20mysterious%20figure%20in%20shadow%2C%20rainy%20street%2C%20neon%20light%20reflections%2C%20tense%20atmosphere%2C%20Chinese%20crime%20thriller%20poster%20style%2C%20cinematic%20lighting&width=800&height=500&seq=card-02&orientation=landscape',
    description: '黑与白的较量从未停止，一场席卷全城的暗流即将爆发',
  },
  {
    title: '《雪国列车》韩剧版热播',
    tag: '韩剧热播',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20snowy%20train%20in%20frozen%20wasteland%2C%20dramatic%20winter%20landscape%2C%20warm%20interior%20light%20through%20train%20windows%2C%20emotional%20character%20portrait%2C%20cinematic%20Korean%20drama%20aesthetic%2C%20soft%20blue%20tones&width=800&height=500&seq=card-03&orientation=landscape',
    description: '末世列车上的生存游戏，人性与权力的终极对决',
  },
  {
    title: '《封神第二部》即将公映',
    tag: '奇幻史诗',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20poster%20with%20ancient%20mythological%20warriors%2C%20golden%20armor%2C%20dramatic%20skies%2C%20mythical%20creatures%2C%20grand%20battle%20scene%2C%20cinematic%20composition%2C%20warm%20gold%20and%20red%20tones&width=800&height=500&seq=card-04&orientation=landscape',
    description: '神话史诗再续传奇，诸神之战撼天动地',
  },
  {
    title: '《漫长的季节》续集开播',
    tag: '悬疑剧集',
    image: 'https://readdy.ai/api/search-image?query=Suspense%20drama%20poster%20with%20autumn%20forest%20and%20railway%2C%20nostalgic%20atmosphere%2C%20golden%20hour%20lighting%2C%20mysterious%20figure%20walking%20away%2C%20Chinese%20northern%20industrial%20town%2C%20cinematic%20warm%20amber%20tones%2C%20emotional%20depth&width=800&height=500&seq=card-05&orientation=landscape',
    description: '时光深处的秘密，一个东北小城跨越二十年的命运交织',
  },
  {
    title: '《异形：夺命舰》全网首发',
    tag: '科幻恐怖',
    image: 'https://readdy.ai/api/search-image?query=Space%20horror%20movie%20poster%20with%20dark%20spaceship%20corridor%2C%20red%20emergency%20lights%2C%20tense%20atmosphere%2C%20shadows%20and%20silhouettes%2C%20alien%20threat%20implied%2C%20cinematic%20sci-fi%20horror%20aesthetic%2C%20deep%20red%20and%20black%20tones&width=800&height=500&seq=card-06&orientation=landscape',
    description: '宇宙深处的终极恐惧，一场无法逃脱的生死猎杀',
  },
];

export const commentItems = [
  {
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20person%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20modern%20casual%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2026-07-28',
    content: '用了51影院半年多了，资源更新速度真的快！第九影院和yy影院的热门资源基本同步，画质也很清晰，最重要的是没有烦人的广告弹窗，追剧体验超棒！',
    rating: 5,
  },
  {
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%2C%20soft%20natural%20lighting%2C%20gentle%20smile%2C%20clean%20white%20background%2C%20modern%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2026-07-25',
    content: '作为一个重度追剧党，51影院真的是我的救星！看吧影院和九九影院的资源整合在一起，再也不用跳来跳去找资源了。特别是韩剧和美剧的更新速度，比很多付费平台还快！',
    rating: 5,
  },
  {
    name: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20Chinese%20man%2C%20warm%20lighting%2C%20confident%20expression%2C%20clean%20white%20background%2C%20business%20casual%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2026-07-22',
    content: '推荐给了身边很多朋友，18影院的影视大全分类很齐全，找老片子也方便。播放流畅不卡顿，手机和电脑都能看，晚上躺在床上追剧太惬意了。',
    rating: 4,
  },
];

export const faqItems = [
  {
    question: '51影院需要付费吗？资源是免费的吗？',
    answer: '51影院整合第九影院、yy影院、看吧影院、九九影院、18影院等多家平台资源，全部免费高清在线观看，无需注册登录，不收取任何费用。我们致力于为影迷提供最便捷的观影体验。',
  },
  {
    question: '影片画质怎么样？支持哪些清晰度？',
    answer: '51影院的影片资源以高清和超清为主，大部分影片支持1080P画质，部分热门资源提供4K超清画质。播放流畅度取决于您的网络环境，建议在Wi-Fi或稳定网络下观看以获得最佳体验。',
  },
  {
    question: '可以在手机上观看吗？需要下载APP吗？',
    answer: '51影院完美适配手机、平板和电脑端，无需下载任何APP，打开浏览器即可在线观看。网页采用响应式设计，自动适配不同屏幕尺寸，提供便捷的移动观影体验。',
  },
  {
    question: '资源多久更新一次？新片上线速度快吗？',
    answer: '51影院每日更新300+部影片资源，热门院线电影下映后7-15天内上线，热门剧集实现同步更新。我们会持续追踪第九影院、yy影院等平台的最新资源动态，确保影迷第一时间看到想看的内容。',
  },
  {
    question: '播放过程中会出现广告吗？',
    answer: '51影院承诺观影过程中不插入任何广告弹窗，播放页面干净清爽。我们深知广告对观影体验的破坏，因此坚持纯净播放，让每一位影迷享受沉浸式的追剧时光。',
  },
];

export const carouselItems = [
  {
    title: '2026暑期档观影指南',
    tag: '专题策划',
    image: 'https://readdy.ai/api/search-image?query=Summer%20movie%20collage%20with%20cinema%20elements%2C%20film%20strips%2C%20popcorn%2C%20warm%20summer%20vibes%2C%20golden%20hour%20lighting%2C%20movie%20theater%20ambience%2C%20cinematic%20composition%2C%20bright%20and%20vibrant%20colors&width=1200&height=600&seq=carousel-01&orientation=landscape',
    description: '今年暑期档堪称近年来最强，国内外大片扎堆上映，我们为你精选了最值得期待的十部影片',
  },
  {
    title: '国产科幻崛起之路',
    tag: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20visual%20with%20futuristic%20city%20and%20spaceships%2C%20epic%20scale%2C%20warm%20golden%20and%20cool%20blue%20lighting%20contrast%2C%20cinematic%20grandeur%2C%20technological%20aesthetics&width=1200&height=600&seq=carousel-02&orientation=landscape',
    description: '从《流浪地球》到《三体》，国产科幻电影正在经历前所未有的黄金时代',
  },
  {
    title: '经典港片修复重映',
    tag: '怀旧经典',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20film%20nostalgic%20visual%20with%20neon%20signs%2C%20old%20cinema%20marquee%2C%20vintage%20movie%20posters%2C%20warm%20retro%20lighting%2C%2080s%2090s%20Hong%20Kong%20street%20atmosphere%2C%20cinematic%20golden%20tones&width=1200&height=600&seq=carousel-03&orientation=landscape',
    description: '那些年我们追过的港片经典，经过4K修复后重现大银幕，每一帧都是回忆',
  },
  {
    title: '韩剧夏季档追剧日历',
    tag: '追剧指南',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%20visual%20with%20cherry%20blossoms%20and%20warm%20sunlight%2C%20romantic%20atmosphere%2C%20soft%20pastel%20colors%2C%20cozy%20cafe%20scene%2C%20cinematic%20Korean%20style%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
    description: '七八月韩剧神仙打架，李敏镐、宋慧乔等顶流回归，这份追剧日历请收好',
  },
  {
    title: '不能错过的纪录片',
    tag: '精品推荐',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20visual%20with%20sweeping%20landscapes%2C%20mountains%20and%20oceans%2C%20wildlife%20in%20natural%20habitat%2C%20dramatic%20natural%20lighting%2C%20cinematic%20wide%20shots%2C%20earth%20tones%20and%20deep%20greens&width=1200&height=600&seq=carousel-05&orientation=landscape',
    description: '足不出户看世界，这些高分纪录片带你探索地球的每一个神奇角落',
  },
  {
    title: '悬疑烧脑片单精选',
    tag: '影单推荐',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20visual%20with%20dim%20lighting%2C%20magnifying%20glass%2C%20old%20books%2C%20detective%20noir%20atmosphere%2C%20shadows%20and%20light%20play%2C%20cinematic%20suspense%20aesthetic%2C%20warm%20amber%20and%20deep%20shadows&width=1200&height=600&seq=carousel-06&orientation=landscape',
    description: '反转再反转！这些高分悬疑片让你从头猜到尾，结局绝对意想不到',
  },
];

export const appItem = {
  title: '随时随地，手机看片更自由',
  description: '51影院完美适配手机浏览器，无需下载安装，打开即看。支持横竖屏切换，流量优化播放，地铁上、午休时、睡前时光，好片随时相伴。收藏本站到手机桌面，体验与APP一样流畅的观影感受。',
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20movie%20streaming%20interface%20in%20hand%2C%20dark%20cinematic%20UI%20design%2C%20modern%20phone%20mockup%2C%20clean%20white%20background%2C%20minimal%20product%20photography%2C%20soft%20lighting&width=600&height=800&seq=app-01&orientation=portrait',
};

export const featureItems = [
  {
    icon: 'ri-shield-check-fill',
    title: '纯净观影',
    description: '全程无广告弹窗干扰，观影页面干净清爽，沉浸式追剧体验不打折',
  },
  {
    icon: 'ri-flashlight-fill',
    title: '极速加载',
    description: '全球CDN加速节点覆盖，视频秒加载不卡顿，拖动进度条即拖即播',
  },
  {
    icon: 'ri-stack-fill',
    title: '海量资源',
    description: '整合九大影视平台资源，涵盖电影、剧集、综艺、动漫、纪录片全品类',
  },
  {
    icon: 'ri-smartphone-fill',
    title: '多端适配',
    description: '电脑、平板、手机全平台兼容，响应式设计自动适配，随时随地畅快观影',
  },
];

export const rankingItems = [
  { rank: 1, title: '《流浪地球3》', tag: '科幻', hot: '987万', trend: 'up' },
  { rank: 2, title: '《狂飙：暗流》', tag: '犯罪', hot: '856万', trend: 'up' },
  { rank: 3, title: '《雪国列车》韩剧版', tag: '韩剧', hot: '743万', trend: 'up' },
  { rank: 4, title: '《封神第二部》', tag: '奇幻', hot: '691万', trend: 'stable' },
  { rank: 5, title: '《漫长的季节》续集', tag: '悬疑', hot: '628万', trend: 'up' },
  { rank: 6, title: '《异形：夺命舰》', tag: '科幻', hot: '574万', trend: 'new' },
];

export const updateItems = [
  { date: '07-30', title: '《流浪地球3》高清资源独家上线', tag: '新片' },
  { date: '07-29', title: '2026年艾美奖提名剧集专题合集上线', tag: '专题' },
  { date: '07-28', title: '《狂飙：暗流》第8集更新，剧情峰回路转', tag: '更新' },
  { date: '07-27', title: '暑期档动画电影专区全新改版', tag: '改版' },
  { date: '07-26', title: '新增4K超清画质专区，百部经典重制上线', tag: '升级' },
  { date: '07-25', title: '《雪国列车》韩剧版收视率突破新高', tag: '热播' },
  { date: '07-24', title: '「午夜影院」恐怖片专题策划上线', tag: '专题' },
  { date: '07-23', title: '国产纪录片《山海之间》全网抢先上线', tag: '首发' },
  { date: '07-22', title: '服务器全面升级完成，观影体验更流畅', tag: '公告' },
];

export const contactItem = {
  title: '联系与投稿',
  description: '如果您有资源推荐、观影建议或合作意向，欢迎通过以下方式与我们取得联系。我们重视每一位影迷的反馈，共同打造更好的免费观影平台。',
  email: 'feedback@51cinema.com',
  wechat: 'cinema51_official',
  qq: '800123456',
};

export const topicItems = [
  { name: '流浪地球3', count: '128.7万' },
  { name: '国产科幻', count: '96.3万' },
  { name: '韩剧推荐', count: '85.1万' },
  { name: '悬疑烧脑', count: '72.8万' },
  { name: '经典港片', count: '68.4万' },
  { name: '动漫追番', count: '59.2万' },
  { name: '综艺热播', count: '51.7万' },
  { name: '纪录片精选', count: '43.9万' },
  { name: '4K超清', count: '38.5万' },
  { name: '暑期档', count: '32.1万' },
];

export const aboutItem = {
  title: '关于51影院',
  description: '51影院是一个专注于整合优质影视资源的免费高清在线观影平台。我们汇聚了第九影院、yy影院、看吧影院、九九影院、18影院等多平台的丰富内容，致力于为全国影迷提供一站式的便捷观影服务。从热门院线大片到经典老片，从国产热剧到海外佳作，51影院每日更新海量资源，坚持纯净无广告的播放体验。无论你是动作片爱好者、韩剧迷还是纪录片发烧友，都能在这里找到属于自己的光影世界。',
};

export const mediaItems = [
  {
    title: '《流浪地球3》幕后花絮独家揭秘',
    duration: '12:36',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20sci-fi%20movie%20production%2C%20film%20crew%20working%20on%20set%2C%20green%20screen%20studio%2C%20professional%20camera%20equipment%2C%20cinematic%20lighting%2C%20documentary%20style%20photography%2C%20warm%20studio%20tones&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    title: '专访：《狂飙》导演谈续集创作理念',
    duration: '25:18',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20interview%20scene%2C%20professional%20studio%20lighting%2C%20director%20chair%2C%20movie%20posters%20on%20wall%2C%20cinematic%20atmosphere%2C%20warm%20interview%20lighting%2C%20film%20making%20documentary%20style&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    title: '2026暑期档新片预告混剪合集',
    duration: '08:52',
    image: 'https://readdy.ai/api/search-image?query=Movie%20trailer%20editing%20suite%20with%20multiple%20screens%2C%20film%20editing%20timeline%2C%20cinematic%20color%20grading%2C%20professional%20video%20editing%20setup%2C%20dark%20room%20with%20monitor%20glow%2C%20creative%20post%20production&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const footerLinks = [
  { label: '热门推荐', href: '#cards' },
  { label: '热播榜单', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
  { label: '手机看片', href: '#app' },
  { label: '联系我们', href: '#contact' },
];